<template>
  <div>
    <v-card class="card-shadow border-radius-xl pa-6">
      <div class="pb-4">
        <h6 class="text-typo text-h6 font-weight-bold">
          Créer un nouveaux client
        </h6>
      </div>
      <div v-if="loading" class="grid-center-h-v">
        <v-progress-circular
          :size="32"
          :width="2"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-card-text v-else>
        <div class="mb-4">
          <label class="text-xs text-typo font-weight-bolder ms-1"
            >NOM DE L'ENTREPRISE (Pour les utilisateurs)</label
          >
          <v-text-field
            v-model="displayname"
            hide-details
            outlined
            color="rgba(0,0,0,.6)"
            light
            placeholder=""
            class="
              font-size-input
              placeholder-lighter
              border border-radius-md
              text-light-input
            "
          ></v-text-field>
        </div>
        <p>
          {{
            isClientAlreadyExist
              ? "Le client existe déjà merci de saisir un autre nom"
              : ""
          }}
        </p>
        <BtnBlue
          :btnTitle="$t('appButton.save')"
          @clicked="postNewClient"
          :disabled="canCreateClient"
        ></BtnBlue>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import BtnBlue from "../common/BtnBlue.vue";

export default {
  name: "ClientAttributesCreate",

  components: {
    BtnBlue,
  },

  props: {
    editAttribut: {
      type: [Object, null],
      default: null,
    },
  },

  data() {
    return {
      loading: false,
      displayname: "",
    };
  },

  computed: {
    isClientAlreadyExist() {
      const data = {
        displayname: this.displayname,
      };
      return this.$store.getters.isClientAlreadyExist(data);
    },

    canCreateClient() {
      return this.displayname.length > 3 && !this.isClientAlreadyExist;
    },
  },

  methods: {
    async postNewClient() {
      this.loading = true;
      const data = {
        displayname: this.displayname.trim(),
      };
      await this.$store.dispatch("post_new_client", data);
      this.loading = false;
      this.initState();
      this.$emit("closeDialog");
    },

    initState() {
      this.loading = false;
      this.name = "";
    },
  },
};
</script>

<style scoped></style>
